<google-chart id='TotalValueChart' [type]="chartType" [data]="myData" [options]="options" [style]="cStyle"></google-chart>

